import {
  DeleteOutlined,
  FormOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import React, { Fragment, useState } from "react";
import ButtonComponent from "../../components/Button/ButtonComponent";
import PageHeader from "../../components/PageHeader/PageHeader";
import TableComponent from "../../components/Table/TableComponent";
import IntlMessages from "../../util/IntlMessages";
import { TodayAppoinment } from "./data";
import { Row, Col, Tabs, Popconfirm, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import useSelection from "antd/lib/table/hooks/useSelection";
import { useEffect } from "react";
import {
  getPatientAppoinmentListInProgress,
  getUpcomingPatientAppoinmentListInProgress,
  patientDeleteAppointmentListInProgress,
  patientUpcomingDeleteAppointmentListInProgress,
} from "../../appRedux/Patient/Action/Action";
import PatientHeader from "../Patient/components/PatientHeader/PatientHeader";
import PatientAppointmentHeader from "./PatientAppointmentHeader";
import { Link } from "react-router-dom";
import TabPane from "antd/lib/tabs/TabPane";
import moment from "moment";
const PatientAppoinments = () => {
  const columns = [
    {
      title: "Patient Name",
      dataIndex: "patient_name",
    },
    {
      title: "Doctor Name",
      dataIndex: "doctor_name",
    },
    {
      title: "Week Day",
      dataIndex: "week_day",
    },
    {
      title: "Start Time",
      dataIndex: "start_time",
      render: (start_time) => moment(start_time, ["h:mm A"]).format("hh:mm A"),
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      render: (end_time) => moment(end_time, ["h:mm A"]).format("hh:mm A"),
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
    {
      title: "Symptom",
      dataIndex: "symptom",
    },
    {
      title: "action",
      dataIndex: "action",
      render: (_, record) => {
        const confirm = () => {
          handleDelete(record.id);
          message.success("Deleted successfully");
        };
        const cancel = () => {
          message.success("cancelled");
        };
        return (
          <Row className="appoinment-row">
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={8}
              className="appoinment-button"
            >
              <ButtonComponent
                type="primary"
                icon={<HistoryOutlined />}
              ></ButtonComponent>
            </Col>
            {/* <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={8}
              className="appoinment-button"
            >
            <Link to={`/patientAppointment/edit/${record.id}`}>

              <ButtonComponent
                type="primary"
                icon={<FormOutlined />}
              ></ButtonComponent>
              </Link>
            </Col> */}
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={8}
              className="appoinment-button"
            >
              {" "}
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={confirm}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <ButtonComponent
                  type="danger"
                  icon={<DeleteOutlined />}
                ></ButtonComponent>
              </Popconfirm>
            </Col>
          </Row>
        );
      },
    },
  ];
  const currentDate = moment(new Date()).format("YYYY-MM-DD");
  const [currentTime, setCurrentTime] = useState(moment().format("hh:mm A"));
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format("hh:mm A"));
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const dispatch = useDispatch();
  const patientAppList = useSelector((state) => state.patientAppointment);
  const patList = patientAppList.getAppointmentList?.data?.data;
  const totalRecord = patList?.totalRecords;
  const deleteAppList = useSelector(
    (state) => state.patientAppointment.deleteAppointmentList
  );
  console.log("patList", patList);

  const handleDelete = (id) => {
    let i = patList && patList.filter((val) => val.id === id);
    console.log("i", i);
    console.log("delete");
    dispatch(patientDeleteAppointmentListInProgress(i[0].id));
  };

  const patient_id = localStorage.getItem("patient_id");
  const id = localStorage.getItem("id");

  useEffect(() => {
    handlePage(1);
  }, [deleteAppList]);

  const handlePage = (page) => {
    dispatch(
      getPatientAppoinmentListInProgress({ page, currentDate, currentTime })
    );
  };
  return (
    <Fragment>
      <PageHeader
        header={<IntlMessages id={"Appointment.patientpreviousappointment"} />}
        accessData="false"
      />
      <TableComponent
        columns={columns}
        dataSource={patList}
        pagination={{
          total: totalRecord,
          onChange: (page) => handlePage(page),
        }}
        itemList={patList}
      />
    </Fragment>
  );
};

export default PatientAppoinments;
